<template>
	<div class="sidebar-fix-outer">
		<span v-if="$store.state.sidebarStatus == 'false'" class="sidebar-handle" @click="sideFoldClick"></span>
		<span v-if="$store.state.sidebarStatus == 'true'" class="sidebar-handle" @click="sideOpenClick"></span>
		<div v-if="pageTitle == 'account'">
			<div class="sidebar-fix">
				<h3>账户设置</h3>
				<ul>
					<li><router-link to="/account/index">安全设置</router-link></li>
					<li><router-link to="/account/info">基本资料</router-link></li>
					<li><router-link to="/account/pwd">修改密码</router-link></li>
					<li><router-link to="/account/message">站内信管理</router-link></li>
					<li><router-link to="/account/log">日志管理</router-link></li>
					<li><router-link to="/account/notice">通知设置</router-link></li>
					<li><router-link to="/verify">实名认证</router-link></li>
					<li><router-link to="/account/address">常用地址管理</router-link></li>
				</ul>
			</div>
		</div>
		<div v-if="pageTitle == 'financial'">
			<div class="sidebar-fix">
				<h3>财务记录</h3>
				<ul>
					<li><router-link to="/financial/pay">充值中心</router-link></li>
					<li><router-link to="/financial/index">收支明细(完)</router-link></li>
					<li><router-link to="/order">订单管理</router-link></li>
					<li><router-link to="/financial/cash">代金券明细(完)</router-link></li>
					<li><router-link to="/invoice">发票管理</router-link></li>
					<li><router-link to="/refund">退款管理</router-link></li>
					<li><router-link to="/financial/coupon">优惠券管理(完)</router-link></li>
					<li><router-link to="/financial/out">用户财务转出</router-link></li>
					<li><router-link to="/finance/arrears_list">欠款记录(完)</router-link></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
		import { ref } from 'vue'
		import { useStore } from 'vuex'
		
		const store = useStore()
		const sidebarStatus = store.state.sidebarStatus
		const props = defineProps({ pageTitle: String });
		
		const sideFoldClick = () => {
			store.commit("setsideStatus", 'true')
		}
		const sideOpenClick = () => {
			store.commit("setsideStatus", 'false')
		}
</script>

